import styled, { keyframes } from "styled-components";
import loadingGif from '../images/loading.gif';

const loading = keyframes`
  0 { 
    opacity: 1;
  }
  99% { 
    opacity: 1;
  }
  100% { 
    opacity: 0;
    visibility: hidden;
  }
`
const Loading = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  background-color: #fff;
  z-index: 1002;
  animation: ${loading} 4.4s;
  animation-fill-mode: forwards;
`

const Gif = styled.img`
  margin: auto;
  @media (max-width: 768px) {
    width: 300%;
    transform: translateX(-33%);
  }
`



const LoadingMask = () => {
  return <Loading>
    <Gif src={loadingGif} alt="" />
  </Loading>
}

export default LoadingMask